import React, { useEffect } from 'react';
import { Card } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Group as GroupIcon } from '@material-ui/icons';

import CardTitle from '../../common/card/CardTitle';
import CardContent from '../../common/card/CardContent';
import { useGetEmployeeStats } from '../../user/User.hooks';
import EmployeeChart from './EmployeeChart';

const EmployeeChartCard: React.FC = () => {
  const [{ data }, get] = useGetEmployeeStats();
  const { totalUsers = 0, stats = [] } = data || {};

  useEffect(() => {
    get();
  }, [get]);

  return (
    <Card>
      <CardTitle>
        <GroupIcon />
        Employee Training Compliance
      </CardTitle>
      <CardContent>
        <div>
          <Alert severity='info'>
            <span>
              Total Users assigned Training: <strong>{totalUsers}</strong>
            </span>
          </Alert>
          <EmployeeChart stats={stats} />
        </div>
      </CardContent>
    </Card>
  );
};

export default EmployeeChartCard;
